var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vx-row mt-4 mb-10" }, [
    _c("div", { staticClass: "vx-col w-full" }, [
      _c(
        "div",
        { staticClass: "flex flex-wrap items-center" },
        [
          _c(
            "vue-dropzone",
            {
              ref: "fileUploadZone",
              staticStyle: { width: "100%", "margin-bottom": "10px" },
              attrs: {
                id: "upload",
                "use-font-awesome": true,
                options: _vm.dropzoneOptions,
                "use-custom-dropzone-options": true,
                useCustomSlot: true,
              },
              on: {
                "vdropzone-success": _vm.successSendFile,
                "vdropzone-sending": _vm.sending,
                "vdropzone-error": _vm.error,
                "vdropzone-file-added": _vm.added,
                "vdropzone-queue-complete": _vm.complete,
              },
            },
            [
              _c("div", { staticClass: "dropzone-custom-content" }, [
                _c("h3", { staticClass: "dropzone-custom-title" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("messages.drag_and_drop_image")) + " "
                  ),
                ]),
                _c("div", { staticClass: "subtitle" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("messages.or_select_file_in_computer")) +
                      " "
                  ),
                ]),
                _vm.hint
                  ? _c("div", { staticClass: "subtitle" }, [
                      _vm._v(" " + _vm._s(_vm.hint) + " "),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt-2 w-full" },
        [
          _c("media-list", {
            attrs: {
              medias: _vm.imagesList,
              "show-delete": true,
              "action-on-click": false,
            },
            on: { deleteMedia: _vm.deleteImage },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }